import { createIcon } from '../icons/utils';

/**
 * Legacy ProgressBars' "opened, but nothing written yet" glyph: the open envelope
 * with the red "!" badge in its bottom-right corner.
 *
 * The badge means the same thing here as on `ProcessedWithoutNoteIcon` — no note has
 * been recorded — so the two read as one family. The envelope paths are the same ones
 * `OpenEnvelopePatientTimelineIcon` draws, which is what an opened transmission WITH a
 * note shows; the badge is the only difference between the two states.
 */
export const OpenEnvelopeNoNoteIcon = createIcon(
  ({ ref, className, innerClassName, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0.650146 8.73127C0.650146 8.03118 1.01622 7.38205 1.61531 7.0198L11.1153 1.27562C11.7516 0.890904 12.5487 0.890904 13.185 1.27562L22.685 7.0198C23.2841 7.38205 23.6501 8.03118 23.6501 8.73127V21.6499C23.6501 22.7545 22.7547 23.6499 21.6501 23.6499H2.65015C1.54558 23.6499 0.650146 22.7545 0.650146 21.6499V8.73127Z"
        className={innerClassName}
        fillOpacity={0.16}
      />
      <path
        d="M10.1446 1.55019L3.02359 6.39324C2.23256 6.93122 1.83705 7.20021 1.70007 7.54133C1.58036 7.83944 1.58036 8.17542 1.70007 8.47353C1.83705 8.81465 2.23256 9.08364 3.02359 9.62163L10.1446 14.4647C10.8705 14.9584 11.2335 15.2052 11.6246 15.3013C11.9703 15.3862 12.33 15.3862 12.6757 15.3013C13.0668 15.2052 13.4298 14.9584 14.1557 14.4647L21.2767 9.62163C22.0677 9.08365 22.4632 8.81465 22.6002 8.47353C22.7199 8.17542 22.7199 7.83944 22.6002 7.54133C22.4632 7.20021 22.0677 6.93122 21.2767 6.39324L14.1557 1.55019C13.4298 1.05648 13.0668 0.809625 12.6757 0.713577C12.33 0.628677 11.9703 0.628677 11.6246 0.713577C11.2335 0.809625 10.8705 1.05648 10.1446 1.55019L1.48737 7.43803C1.18146 7.64608 1.02851 7.75011 0.917691 7.88886C0.819595 8.01169 0.745907 8.15377 0.700942 8.30676C0.650146 8.4796 0.650146 8.67048 0.650146 9.05223V17.8742C0.650146 19.8959 0.650146 20.9067 1.02617 21.6789C1.35694 22.3581 1.88472 22.9104 2.53388 23.2565C3.27187 23.6499 4.23797 23.6499 6.17015 23.6499H18.1301C20.0623 23.6499 21.0284 23.6499 21.7664 23.2565C22.4156 22.9104 22.9434 22.3581 23.2741 21.6789C23.6501 20.9067 23.6501 19.8959 23.6501 17.8742V9.05223C23.6501 8.67048 23.6501 8.4796 23.5994 8.30676C23.5544 8.15377 23.4807 8.01169 23.3826 7.88886C23.2718 7.75011 23.1188 7.64608 22.8129 7.43803L14.1557 1.55019M23.0751 21.2434L15.4359 14.0238M8.86439 14.0238L1.22515 21.2434"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* The same overhanging badge `ProcessedWithoutNoteIcon` carries, so "no note
          recorded" reads identically on both, and padded the same way legacy padded
          that glyph: the viewBox gains 4 units in each axis, the envelope keeps its
          0.65-23.65 box, and the caller shifts the icon down-right by half the padding
          so the envelope stays on the lane's shared centre. The circle sits at the same
          fraction across the envelope as legacy's does (85%, radius 27% of its width). */}
      <circle
        cx={20.3}
        cy={20.3}
        r={6.25}
        fill="white"
        stroke="hsl(var(--themed-red-600))"
        strokeWidth={1.5}
      />
      <path
        d="M20.3 20.93V17.18M20.3 23.11H20.3065"
        stroke="hsl(var(--themed-red-600))"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'OpenEnvelopeNoNoteIcon', defaultSize: 25, classNameBase: '' },
);
